// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"1a365720","428":"945f6611"}[chunkId] + ".chunk.css";
};